/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { BreakpointContext } from "components/common";
import { ProductTermToggle } from "@tomocredit/common-fe/components";
import { boostTiers } from "@tomocredit/common-fe/consts";
import TestimonialPricing from "images/boost/testimonal-pricing.webp";
import { BoostPricingComponent } from "./components/BoostPricingComponent";
import BoostContainer from "./components/BoostContainer";
import "./BoostLandingStyle.css";

const BoostPricing = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md"); // 768

  const queryParameters = new URLSearchParams(window.location.search);
  const tierRaw = queryParameters.get("tier");
  const termRaw = queryParameters.get("term");
  const emailFromQueryParam = queryParameters.get("email");

  const tierFromQueryParam = tierRaw in boostTiers ? tierRaw : null;
  const termFromQueryParam = ["yearly", "monthly"].includes(termRaw)
    ? termRaw
    : null;

  const [checkoutTier, setCheckoutTier] = useState(
    tierFromQueryParam || boostTiers.VIP,
  );

  /* TC-3456 Monthly Only */
  const isMonthlyOnlyTesting = false;
  const testTerm = (isMonthlyOnlyTesting && "monthly") || null;

  const [checkoutTerm, setCheckoutTerm] = useState(
    testTerm || termFromQueryParam || "monthly",
  );

  const history = useHistory();

  const tiers = [boostTiers.VIP, boostTiers.PREMIUM, boostTiers.BASIC];

  const redirectToCheckout = (tier, term, email) => {
    window.fbq?.("track", "Lead");
    window.gtag?.({
      event: "Lead",
      email,
      tier,
      term,
    });
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("term", term);
    urlParams.set("tier", tier);
    urlParams.set("email", email);
    const checkoutUrl = `/boost-checkout?${urlParams.toString()}`;
    history.push(checkoutUrl);
  };

  // select the centered tier if previously-select tier not exist due to term change
  useEffect(() => {
    if (!tiers.includes(checkoutTier)) {
      setCheckoutTier(tiers[1]);
    }
  }, [checkoutTerm]);

  return (
    <div className="w-full h-full relative">
      <BoostContainer relative disablePopup background="pricing">
        <div className="mx-auto text-white flex flex-col items-center h-full w-full py-10 mdl:py-20 z-50 space-y-10">
          <div className="mt-3 md:mt-0 flex flex-col items-center">
            <div className="text-center mb-6" style={{ fontSize: 28, width: belowMd ? 342 : undefined }}>Meet the AI Credit Engine that <span className="font-bold text-boost-primary-200">Manages & Builds</span> Your Credit</div>
            <img src={TestimonialPricing} alt="" style={{ objectFit: "cover", height: belowMd ? 76 : 114, width: "auto" }} />
          </div>
          {!isMonthlyOnlyTesting && (
            <div className="pb-4">
              <ProductTermToggle
                checkoutTerm={checkoutTerm}
                setCheckoutTerm={setCheckoutTerm}
                belowMd={belowMd}
              />
            </div>
          )}
          <BoostPricingComponent
            tiers={tiers}
            checkoutTier={checkoutTier}
            checkoutTerm={checkoutTerm}
            checkoutEmail={emailFromQueryParam}
            highlightTier={boostTiers.VIP}
            setCheckoutTier={setCheckoutTier}
            redirectToCheckout={redirectToCheckout}
          />
        </div>
      </BoostContainer>
    </div>
  );
};

export default BoostPricing;
